module.exports = __webpack_public_path__ + "img/digitalOnnuri_1.0a820e18.png";